<template>
  <div class="homePage">
    <!-- 顶部用户 -->
    <div class="homePageTop">
      <div class="homePageTopBox">
        <div class="homePageTopImg">
            <img v-if="$store.state.userMessages.headUrl == null" src="../../assets/users.png" alt=""/>
            <img v-if="$store.state.userMessages.headUrl!==null" :src="$store.state.userMessages.headUrl" alt="" />
        </div>
        <div class="homePageTopTille">
          <h3>{{ $store.state.userMessages.name }}</h3>
          <div class="homePageTopTillemess">
            <p @click="jumpOthers('adr')">收货地址</p>
            <!--<span>|</span>
            <p @click="jumpOthers('user')">账户设置</p>-->
          </div>
        </div>
      </div>

      <div class="homePageTopMess">
        <div class="homePageTopMessBox">
          <p>待付款</p>
          <p class="homePageTopMessBoxNum">{{ payment }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>待发货</p>
          <p class="homePageTopMessBoxNum">{{ delivery }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>待收货</p>
          <p class="homePageTopMessBoxNum">{{ thegoods }}</p>
        </div>
        <i></i>
        <div class="homePageTopMessBox">
          <p>待评价</p>
          <p class="homePageTopMessBoxNum">{{ evaluation }}</p>
        </div>
      </div>
    </div>
    <!-- 下半部分 -->
    <div class="homePageBottom">
      <!-- 左边 -->
      <div class="homePageBottomL">
        <!-- 我的订单 -->
        <div class="homeBottonL">
          <div class="homeBottonLTitle">
            <p>我的订单</p>
            <span @click="jumpOthers('allOrder')">全部订单</span>
          </div>
            <div class="homeBottonLTitleBox">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :name="tabsItems.id" v-for="(tabsItems,index) in tabsList" :key="index">
                        <span slot="label" class="homeBottonLTitleBox_tab">
                            <i>{{tabsItems.name}}</i>
                            <el-badge :value="tabsItems.orderTodo" size="mini" class="item"></el-badge>
                        </span>
                         <div v-if="tabsItems.listMessage.length==0" style="text-align:center;margin-bottom:20px" >
                              <img src="../../assets/暂无订单.jpg" alt="" style="width:200px">
                          </div>
                        <div class="myOrderList" v-for="(mess,messIndex) in tabsItems.listMessage" :key="messIndex">
                            <div class="myOrderList_box" style="width: 60%;" v-if="tabsItems.type === 'print' && messIndex < 4">
                                <model-stl
                                    class="modelStl"
                                    :backgroundAlpha="0"
                                    :src="mess.list[0].url">
                                </model-stl>
                                <div class="myOrderList_box_mess">
                                    <div class="myOrderList_box_messText" style="cursor: pointer" @click="onClickMyorder('printOrderDetails',mess.uuid,'allOrder')">
                                        <h4 v-for="(item,index) in mess.list" :key="index">
                                            {{item.name}}
                                            <span v-if="index<mess.list.length-1"></span>
                                        </h4>
                                    </div>
                                    <div class="myOrderList_box_messText">
                                        <p class="messTextPone">{{mess.technologyName}}</p>
                                        <span></span>
                                        <p class="messTextP">
                                          {{mess.firstMaterialName}}/{{mess.secondMaterialName}}
                                        </p>
                                        <span></span>
                                        <p  class="messTextPone">{{mess.orderBase.totalNum}}个</p>
                                        <span></span>
                                        <p v-text="validate.fontNumber(mess.enterPriseName)">{{mess.enterPriseName}}</p>
                                        <span></span>
                                        <p>{{mess.orderBase.createDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="myOrderList_box" style="width: 45%;" v-if="tabsItems.type === 'shop' && messIndex < 4">
                                <img :src="mess.specUrl" alt="" v-if="mess.specUrl!=null">
                                <div class="myOrderList_box_mess">
                                    <h4 :key="index" style="cursor: pointer" @click="onClickMyorder('mallOrderDetails',mess.orderBaseUuid,'storOrder')">{{mess.goodsName}}-{{mess.specName}}</h4>
                                    <div class="myOrderList_box_messText">
                                        <p>{{mess.storeName}}</p>
                                        <span></span>
                                        <p>￥{{mess.price}}</p>
                                        <span></span>
                                        <p>{{mess.num}}</p>
                                        <span></span>
                                        <p>{{mess.createDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="myOrderList_box" style="width: 45%;" v-if="tabsItems.type === 'service' && messIndex < 4 && messIndex < 4">
                                <img :src="mess.serviceImg" alt="" v-if="mess.serviceImg!=null">
                                <div class="myOrderList_box_mess">
                                    <h4 :key="index" style="cursor: pointer"  @click="onClickMyorder('serverOrderDetails',mess.uuid,'sercerOr')">{{mess.serviceName}}</h4>
                                    <div class="myOrderList_box_messText">
                                        <p>{{mess.enterPriseName}}</p>
                                        <span></span>
                                        <p>{{mess.orderBase.createDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="myOrderList_box" style="width: 45%;" v-if="tabsItems.type === 'design' && messIndex < 4">
                                <img :src="mess.headUrl" alt="" v-if="mess.headUrl!=null">
                                <div class="myOrderList_box_mess">
                                    <h4 :key="index" style="cursor: pointer"   @click="onClickMyorder('designOrderDetail',mess.uuid,'deg')">{{mess.demandName}}</h4>
                                    <div class="myOrderList_box_messText">
                                        <p>{{mess.designerName}}</p>
                                        <span></span>
                                        <p>{{mess.planDeliveryTime}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="myOrderList_box" style="width: 45%;" v-if="tabsItems.type === 'model' && messIndex < 4">
                                <img :src="mess.modelImg" alt="" v-if="mess.modelImg!=null">
                                <div class="myOrderList_box_mess">
                                    <h4 :key="index" style="cursor: pointer" @click="onClickMyorder('modelOrderDetail',mess.uuid,'modelOr')">{{mess.modelName}}</h4>
                                    <div class="myOrderList_box_messText">
                                        <p>{{mess.modelCreatorName}}</p>
                                        <span></span>
                                        <p>{{mess.orderBase.createDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="myOrderList_box" style="width: 45%;" v-if="tabsItems.type === 'softWare' && messIndex < 4">
                                <img :src="mess.softwareLogo" alt="" v-if="mess.softwareLogo!=null">
                                <div class="myOrderList_box_mess">
                                    <h4 :key="index" style="cursor: pointer" @click="onClickMyorder('softwareOrderDetails',mess.uuid,'softwareOr')" >{{mess.softwareName}}</h4>
                                    <div class="myOrderList_box_messText">
                                        <p>{{mess.userName}}</p>
                                        <span></span>
                                        <p>{{mess.createDate}}</p>
                                    </div>
                                </div>
                            </div>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'model' && messIndex < 4">￥{{mess.orderBase.totalPrice}}</p>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'print' && messIndex < 4">￥{{mess.orderBase.totalPrice}}</p>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'design' && messIndex < 4">￥{{mess.orderBase.totalPrice}}</p>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'softWare' && messIndex < 4">￥{{mess.modelPrice}}</p>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'service' && messIndex < 4">￥{{mess.orderBase.totalPrice}}</p>
                            <p class="myOrderList_money" v-if="tabsItems.type === 'shop' && messIndex < 4">￥{{mess.totalPrice}}</p>

                            <p class="myOrderList_state" v-if="tabsItems.type !== 'softWare'&& messIndex < 4">{{mess.orderBase.orderStatusCn}}</p>
                            <p class="myOrderList_state" v-if="tabsItems.type === 'softWare'&& messIndex < 4">{{mess.stateName}}</p>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 我的收藏 -->
        <div class="homeBottonL">
          <div class="homeBottonLTitle">
            <p>我的收藏</p>
            <span @click="jumpOthers('coll')">全部收藏</span>
          </div>
            <div v-if="collectionList.length==0" style="text-align:center;margin-bottom:20px" >
                <img src="../../assets/暂无收藏.jpg" alt="" style="width:200px">
            </div>
          <div class="collection">
            <div
              class="collectionBox"
              v-for="(collect, index) in collectionList"
              :key="index"
            >
              <div class="iconImgs">
                <img src="@/assets/images/u494.png" alt="" />
                <p>{{ collect.iconmess }}</p>
              </div>
              <div class="collectionBoxImg">

                <img :src="collect.imgs" alt="" />
                <div class="collectionBoxImgName">
                    <a v-if="collect.type=='MODEL'" :href="$url.threeWeb+'/modelDetails?uuid='+collect.uuid" target="_blank"><p>{{ collect.modelName }}</p></a>
                    <a v-else :href="$url.threeWeb+'/shopGoodDetails/'+collect.uuid" target="_blank"><p>{{ collect.modelName }}</p></a>
                  <span>{{ collect.creatorName }}</span>
                </div>

              </div>
              <div class="collectionMoney">
                  <p>￥{{ collect.money==null?"0": collect.money}}</p>
                <!-- <i class="iconfont">&#xe602;</i> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="homePageBottomR">
        <!-- 关注设计师 -->
        <div class="homeBottonR">
          <div class="homeBottonLTitle">
            <p>关注设计师</p>
            <span @click="jumpOthers('des')">全部</span>
          </div>

          <div class="designerFocus" v-if="designerFocusList.length!=0">
            <div
              class="designerFocusMess"
              v-for="(designer, index) in designerFocusList"
              :key="index"
            >
              <img :src="designer.likeInfo.headUrl" alt="" v-if="designer.likeInfo!=null && designer.likeInfo.headUrl != null"/>
              <img src="../../assets/users.png" alt="" v-else/>
                <a :href="$url.threeWeb+'/designModel/'+designer.designer_uuid" target="_blank"><p v-if="designer.likeInfo!=null && designer.likeInfo.nickname != null">{{ designer.likeInfo.nickname }}</p></a>
            </div>
          </div>
            <div v-else style="text-align:center;" >
                <img src="../../assets/暂无关注.jpg" alt="" style="width:200px">
            </div>
        </div>
        <!-- 关注店铺 -->
        <div class="homeBottonR">
          <div class="homeBottonLTitle">
            <p>关注店铺</p>
            <span @click="jumpOthers('store')">全部</span>
          </div>
           <div v-if="shopFocusList.length==0" style="text-align:center;" >
                <img src="../../assets/暂无关注.jpg" alt="" style="width:200px">
            </div>
          <div class="shopFocus">
            <div
              class="shopFocusBox"
              v-for="(shopFocus, index) in shopFocusList"
              :key="index"
            >
              <div class="shopFocusBoxNum">
                <img :src="shopFocus.shopLogo" alt="" v-if="shopFocus.shopLogo!=''"/>
                <img src="@/assets/images/服务商_画板 1.jpg" alt="" v-else/>
                <div class="shopFocusBoxMess">
                  <a :href="$url.threeWeb + '/printServiceIndex/' + shopFocus.enterPriseId" target="_blank"><p>{{ shopFocus.enterPriseName }}</p></a>
                  <!--<span>主营类目：{{ shopFocus.serviceName }}</span>-->
                </div>
              </div>
              <!--<i class="iconfont">&#xe602;</i>-->
            </div>
          </div>
        </div>
        <!-- 足迹 -->
        <div class="homeBottonR">
          <div class="homeBottonLTitle">
            <p>足迹</p>
            <span @click="jumpOthers('brow')">全部</span>
          </div>
           <div v-if="footerList.length==0" style="text-align:center;" >
                <img src="../../assets/暂无足迹.jpg" alt="" style="width:200px">
            </div>
          <div class="footer">
            <div class="footerBox" v-for="(footer,index) in footerList" :key="index" >
                <a :href="footer.link" target="_blank">
              <img :src="footer.logo" alt="" />
              <p>{{footer.title}}</p>
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文字部分 -->
    <div class="textMess">
      <p>
        <span @click="jumpLink('help')">帮助</span>
        <span @click="jumpLink('self')">隐私</span>
        <span @click="jumpLink('mess')">条款</span>
      </p>
      <p>copyright@2021 安徽增材云数字科技有限公司</p>
    </div>
    <!-- 账号管理 -->
    <AccountSet ref="accountSetRef"/>
  </div>
</template>

<script>
import {queryListVisitorLog} from "../../utils/stationMessageLog";
import AccountSet from "./accountSet.vue";

import {getPrintCollectList, getAllShopList,
    getCollectListByMap, getPrintFollowList, findAllDesignList,
    getPrintAndShopOrderNumber, getAllPrintFollow,
    findAllPrintList, findAllServiceList, getModelOrderList, querySoftwareOrderDetailList
} from "../../utils/interface";
import ModelStl from 'vue-3d-model/src/model-stl'

export default {
    name: "homePage",
    data() {
    return {
      // 顶部用户
      payment: 0,
      delivery: 0,
      thegoods: 0,
      evaluation: 0,
      //   我的收藏
      collectionList: [],
      //   关注设计师
      designerFocusList: [],
      //   关注店铺
      shopFocusList: [],
      //   足迹
      footerList: [],
      tabsList: [
          {
              id: 'first',
              name:'打印订单',
              type:'print',
              orderTodo: 0,
              listMessage: []
          },
          {
              id: 'second',
              name:'商城订单',
              type:'shop',
              orderTodo: 0,
              listMessage: []
          },
          {
              id: 'third',
              name:'设计订单',
              type:'design',
              orderTodo: 0,
              listMessage: []
          },
          {
              id: 'fourth',
              name:'模型订单',
              type:'model',
              orderTodo: 0,
              listMessage: []
          },
          {
              id: 'fifth',
              name:'服务订单',
              type:'service',
              orderTodo: 0,
              listMessage: []
          },
          {
              id: 'sixth',
              name:'软件订单',
              type:'softWare',
              orderTodo: 0,
              listMessage: []
          },
      ],
      activeName: 'first',
      navList: this.navList,
      rotation: {
          x: 200,
          y: 0,
          z: 100,
      },
    };
  },
    components: {
        ModelStl,
        AccountSet
    },
    created() {
        this.listVisitorLog();
        this.getPrintFollowList();
        this.getDesignList();
        this.getFollowList();
        // 查询所有打印订单
        this.findAllPrintList();
        // 查询所有设计订单
        this.findAllDesignList();
        // 查询所有服务订单
        this.findAllServiceList();
        // 查询所有模型订单
        this.findAllModelList();
        // 查询所有软件订单
        this.findAllSoftWareList();
        // 查询所有商城订单
        this.getAllShopList();
        // 订单数量
        this.getPrintAndShopOrderNumber();
    },
    methods:{
        getPrintAndShopOrderNumber(){
            getPrintAndShopOrderNumber().then((res)=>{
                if(res&&res.data){
                    this.payment = res.data.payCount!=null?res.data.payCount:0;
                    this.delivery = res.data.sendCount!=null?res.data.sendCount:0;
                    this.thegoods = res.data.afterCount!=null?res.data.afterCount:0;
                    this.evaluation = res.data.appraiseCount!=null?res.data.appraiseCount:0;

                }
            });
        },
        findAllDesignList(){
            findAllDesignList({isBuy:true}).then((res)=>{
                if(res&&res.length>0){
                    this.tabsList[2].orderTodo = res.length;
                    this.tabsList[2].listMessage = res;
                }
            });
        },
        findAllServiceList(){
            findAllServiceList({isBuy:true}).then((res)=>{

                if(res&&res.length>0){
                    this.tabsList[4].orderTodo = res.length;
                    this.tabsList[4].listMessage = res;
                }
            });
        },
        findAllPrintList(){
            findAllPrintList({isBuy:true}).then((res)=>{
                if(res&&res.length>0){
                    this.tabsList[0].orderTodo = res.length;
                    this.tabsList[0].listMessage = res;
                    console.log('this.tabsList[0].listMessage', this.tabsList[0].listMessage[0].list[0].url);
                }
            });
        },
        getAllShopList(){
            getAllShopList().then((res)=>{
                if(res&&res.length>0){
                    this.tabsList[1].orderTodo = res.length;
                    this.tabsList[1].listMessage = res;
                }
            });
        },
        findAllModelList(){
            getModelOrderList({isBuy:true}).then((res) => {
                if(res&&res.total>0){
                    this.tabsList[3].orderTodo = res.total;
                    this.tabsList[3].listMessage = res.list;
                }
            });
        },
        findAllSoftWareList(){
            querySoftwareOrderDetailList({isBuy:true}).then((res) => {
                if(res&&res.total>0){
                    this.tabsList[5].orderTodo = res.total;
                    this.tabsList[5].listMessage = res.list;
                }
            });
        },
        listVisitorLog(){
            queryListVisitorLog().then((res)=>{
                if(res){
                    this.footerList =res;
                }
            });
        },
        // 跳转路由
        jumpOthers(type){
            if(type == 'adr'){
              // 收货地址
                this.$router.push('/tradShippAddress');
                this.$emit('hompageLog','adr')
            }else if (type == 'user'){
              this.$refs.accountSetRef.init()
            }else if (type == 'coll'){
              // 全部收藏
                this.$router.push('/newsManagement');
                this.$emit('hompageLog','coll')

            }else if (type == 'des'){
              // 全部设计师
                this.$router.push('/designerFocus');
                this.$emit('hompageLog','des')

            }else if (type == 'store'){
              // 全部店铺
                this.$router.push('/serviceProviders');
                this.$emit('hompageLog','store')
            }else if (type == 'brow'){
              // 全部足迹
                this.$router.push('/browsingHistory');
                this.$emit('hompageLog','brow')
            }else if (type == 'allOrder'){
                this.$router.push('/printOrderList');
                this.$emit('hompageLog','allOrder')
            }

        },
        // 我的订单列表跳转
        onClickMyorder(pathName,uuid,type){
          this.$emit('hompageLog',type)
          if(type == 'storOrder'){
            this.$router.push({name:pathName,params:{orderBaseUuid:uuid}})
          }else if(type == 'modelOr'){
            this.$router.push({name:pathName,query:{uuid:uuid}})
          }else if(type == 'softwareOr'){
            this.$router.push({name:pathName,query:{uuid:uuid}})
          }else {
            this.$router.push({name:pathName,params:{uuid:uuid}})
          }
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        getPrintFollowList(){
            getAllPrintFollow({isBuy:true}).then((res)=>{
                if(res&&res.length>0){
                    if(res.length>4){
                        this.shopFocusList = res.slice(0,4);
                    }else{
                        this.shopFocusList = res;
                    }
                }
            });
        },
        getDesignList() {
            let data = {
                current: this.pageNo,
                pageSize: this.pageSize,
                likeType: 'DESIGNER',
            }
            getCollectListByMap(data).then((res) => {
                if(res.length>4){
                    this.designerFocusList = res.list.slice(0,4);
                }else{
                    this.designerFocusList = res.list;
                }
            })
        },
        getFollowList() {
            let data = {
                likeType: 'MODEL',
            }
            getCollectListByMap(data).then((res) => {
                if(res.total>0){
                    if(res.list.length >= 3){
                        res.list.slice(0,3).forEach((item)=>{
                            let resData={imgs:item.likeInfo.imgUrl,
                                modelName:item.likeInfo.modelName,
                                money: item.likeInfo.price,
                                creatorName: item.likeInfo.creatorName,
                                uuid:item.likeInfo.uuid,
                                type:"MODEL",
                                iconmess: "模型"}

                            this.collectionList.push(resData);
                        });
                        let params = {
                            type: 1,
                            current:1,
                            isBuy:true,
                        };
                        getPrintCollectList(params).then((res1)=>{
                            if(res1 != null && res1.list != null && res1.list.length > 0){
                                res1.list.slice(0,3).forEach((item)=>{
                                    let resData={imgs:item.imgUrl,
                                        modelName:item.goodsName,
                                        money: item.goodsPrice,
                                        creatorName: item.storeName,
                                        uuid:item.goodsUuid,
                                        type:"SHOP",
                                        iconmess: "商品"}

                                    this.collectionList.push(resData);
                                });
                            }
                        });
                    }else if(res.list.length > 0 && res.list.length  < 3){
                        res.list.forEach((item)=>{
                            let resData={imgs:item.likeInfo.imgUrl,
                                modelName:item.likeInfo.modelName,
                                money: item.likeInfo.price,
                                creatorName: item.likeInfo.creatorName,
                                uuid:item.likeInfo.uuid,
                                type:"MODEL",
                                iconmess: "模型"}

                            this.collectionList.push(resData);
                        });
                        let params = {
                            type: 1,
                            current:1,
                            isBuy:true,
                        };
                        getPrintCollectList(params).then((res1)=>{
                            if(res1 != null && res1.list != null && res1.list.length > 0){

                                res1.list.slice(0,6-this.collectionList.length).forEach((item)=>{
                                    let resData={imgs:item.imgUrl,
                                        modelName:item.goodsName,
                                        money: item.goodsPrice,
                                        creatorName: item.storeName,
                                        uuid:item.goodsUuid,
                                        type:"SHOP",
                                        iconmess: "商品"}

                                    this.collectionList.push(resData);
                                });
                            }
                        });
                    }
                } else{
                    let params = {
                        type: 1,
                        current:1,
                        isBuy:true,
                    };
                    getPrintCollectList(params).then((res1)=>{
                        if(res1 != null && res1.list != null && res1.list.length > 0){
                            res1.list.slice(0,6).forEach((item)=>{
                                console.log(item,222)
                                let resData={
                                    imgs:item.imgUrl === '' || item.imgUrl === null?require('@/assets/images/13哆啦A梦.png'):item.imgUrl,
                                    modelName:item.goodsName,
                                    money: item.goodsPrice,
                                    creatorName: item.storeName,
                                    uuid:item.goodsUuid,
                                    type:"SHOP",
                                    iconmess: "商品"}

                                this.collectionList.push(resData);
                            });
                        }
                    });
                }
            })
        },
        jumpLink (type) {
          if(type == 'help' || type == 'mess'){
            window.open(
                this.$url.threeWeb + '/helpCenter',
                "_blank"
            );
          }else if(type == 'self'){
            window.open(
                this.$url.threeWeb + '/helpCenterDetail?wordNo=ZCYYHYSXY',
                "_blank"
            );

          }
        }
    }
};
</script>

<style scoped  lang="less">
p,
h3 {
  margin: 0;
}
.homePage {
  padding: 20px;
  // 顶部用户
  .homePageTop {
    box-shadow: 0px 0px 5px rgb(228 228 228);
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    margin-bottom: 20px;
    .homePageTopBox {
      display: flex;
    }
    .homePageTopImg {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .homePageTopTille {
      h3 {
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .homePageTopTillemess {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.427);
        display: flex;
        align-items: center;
        span {
          margin: 0 10px;
        }
        p {
          cursor: pointer;
        }
      }
    }
    .homePageTopMess {
      display: flex;
      align-items: center;
      .homePageTopMessBox {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.427);
        text-align: center;
        width: 130px;
        .homePageTopMessBoxNum {
          font-weight: 700;
          font-size: 20px;
          color: rgb(57, 119, 243);
          cursor: pointer;
        }
      }
      i {
        display: inline-block;
        width: 1px;
        height: 30px;
        background: rgb(223, 223, 223);
      }
    }
  }
  //   下半部分
  .homePageBottom {
    display: flex;
    // 左边
    .homePageBottomL {
      margin-right: 20px;
      width: 65%;

      .homeBottonL {
        box-shadow: 0px 0px 5px rgb(228 228 228);
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 1);
        margin-bottom: 20px;
        .homeBottonLTitle {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          border-bottom: 1px solid #efefef;
          padding: 15px 30px;
          p {
            font-weight: 700;
          }
          span {
            color: rgb(24, 144, 255);
            cursor: pointer;
          }
        }
        // 我的订单
        .homeBottonLTitleBox {
          padding: 30px;
          padding-top: 10px;
          height: 410px;
          /deep/.el-tabs__content {
            height: 320px;
            // overflow-y: auto;
            ::-webkit-scrollbar {
              /*隐藏滚轮*/
              display: none !important;
            }
          }
          .homeBottonLTitleBox_tab {
            display: flex;
            align-items: center;
            i {
              font-style:normal
            }
          }
          .myOrderList {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding: 15px;
            .myOrderList_box {
                //width:45%;
              display: flex;
              align-items: center;
              .modelStl {
                min-width: 50px !important;
                width: 50px !important;
                height: 50px !important;
                border-radius: 6px !important;
                margin-right: 6px !important;
                border: 1px solid #efefef !important;
              }
              img {
                width: 50px;
                height: 50px;
                border-radius: 6px;
                margin-right: 6px;
              }
              .myOrderList_box_mess {
                h4 {
                  font-size: 14px;
                  margin: 0;
                }
                .myOrderList_box_messText {
                  display: flex;
                  align-items: center;
                  margin-top: 6px;
                  .messTextPone {
                    max-width: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                  .messTextP {
                    max-width: 90px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                  p {
                    font-size: 12px;
                    color: #727272;
                    white-space: nowrap;

                  }
                  span {
                    margin: 0 6px;
                    display: inline-block;
                    width: 1px;
                    height: 12px;
                    background: #b1b1b1;
                  }
                }

              }
            }
            .myOrderList_money {
                width:10%;
              font-weight: bold;
            }
            .myOrderList_state {
                width:5%;
                color: #1890ff;
                white-space: nowrap;
            }
          }

        }
        // 我的收藏
        .collection {
          padding: 20px 30px 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .collectionBox {
            width: 48%;
            border: 1px solid #efefef;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 68px;
            padding: 0 15px 0 40px;
            margin-right: 20px;
            margin-bottom: 20px;
            position: relative;
            &:nth-of-type(2n + 2) {
              margin-right: 0;
            }
            .iconImgs {
              position: absolute;
              top: 0;
              left: 0;
              img {
                position: relative;
              }
              p {
                position: absolute;
                top: 5px;
                left: 4px;
                font-size: 12px;
                color: rgb(23, 97, 219);
              }
            }
            .collectionBoxImg {
              display: flex;
              align-items: center;
              img {
                width: 50px;
                height: 50px;
                border-radius: 10px;
                margin-right: 5px;
              }
              .collectionBoxImgName {
                a {
                  font-size: 14px;
                  font-weight: 700;
                  color: #000;
                  &:hover {
                    color: rgb(24, 144, 255);
                  }
                }
                span {
                  font-size: 12px;
                  color: rgba(153, 153, 153, 0.847);
                }
              }
            }
            .collectionMoney {
              display: flex;
              align-items: center;
              .iconfont {
                font-size: 30px;
                color: #cadbf7;
                margin-left: 50px;
              }
            }
          }
        }
      }
    }
    // 右边
    .homePageBottomR {
      width: 35%;
      .homeBottonR {
        box-shadow: 0px 0px 5px rgb(228 228 228);
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 1);
        margin-bottom: 20px;
        .homeBottonLTitle {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          border-bottom: 1px solid #efefef;
          padding: 15px 30px;
          p {
            font-weight: 700;
          }
          span {
            color: rgb(24, 144, 255);
            cursor: pointer;
          }
        }
        // 关注设计师
        .designerFocus {
          display: flex;
          // align-items: center;
          //   justify-content: space-around;
          height: 130px;
          padding-top: 20px;
          .designerFocusMess {
            text-align: center;
            width: 25%;
            img {
              width: 47px;
              height: 47px;
              border-radius: 50%;
            }
            a {
              font-size: 14px;
              color: #000;
              &:hover {
                color: rgb(24, 144, 255);
              }
            }
          }
        }
        // 关注店铺
        .shopFocus {
          .shopFocusBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 68px;
            border-bottom: 1px solid #efefef;
            margin: 0 30px;
            .shopFocusBoxNum {
              display: flex;
              align-items: center;
              img {
                height: 40px;
                width: 40px;
                margin-right: 15px;
              }
              .shopFocusBoxMess {
                font-size: 14px;
                a {
                  color: #000;
                  &:hover {
                    color: rgb(24, 144, 255);
                  }
                }
                p {
                  margin-bottom: 5px;
                }
                span {
                  font-size: 12px;
                }
              }
            }
            .iconfont {
              font-size: 30px;
              color: #cadbf7;
            }
          }
        }
        // 足迹
        .footer {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          padding-top: 20px;
          .footerBox {
            width: 25%;
            text-align: center;
            font-size: 14px;
            margin-bottom: 20px;
            img {
              width: 80px;
              height: 80px;
              border-radius: 10px;
              margin-bottom: 5px;
            }
            p {
              width: 80px;
              margin: 0 auto;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            a {
              color: #000;
              &:hover {
                color: rgb(24, 144, 255);
              }
            }
          }
        }
      }
    }
  }
  //   文字部分
  .textMess {
    text-align: center;
    margin-top: 40px;
    p {
      font-size: 14px;
      margin-bottom: 15px;
      span {
        cursor: pointer;
        margin-right: 16px;
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/homePage.vue